<template>
  <div v-if="store.form">
    <!-- <img
        class="logo mx-auto col-4 block mt-2"
        :src="getImgUrl(`${useRuntimeConfig().public.appUrl}/imgs/logos/${store.form.intro.logo_folder}/logo.png`)"
      > -->
    <div class="steps mt-2 col-12 grid justify-content-center">
      <div v-for="(step, stepIndex) in store.form['steps']" :key="stepIndex" class="flex">
        <div
          :class="[
            'step col m-2 justify-content-center',
            store.stepNb === parseInt(stepIndex as unknown as string) ? 'step-selected' : ''
          ]"
        >
          <div class="step-box">
            <span class="title-2"> {{ parseInt(stepIndex as unknown as string) + 1 }} </span>
          </div>
          <!-- <div class="subtitle ml-3 align-self-center col">
              {{ step.name }}
            </div> -->
        </div>
        <!-- <div v-if="store.stepNb === parseInt(stepIndex) && store.stepNb !== Object.entries(store.form.steps).length -1" class="col m-4 align-self-center">
            <div
              :class="[
                'between-step',
                store.stepNb === parseInt(stepIndex) && store.stepNb !== Object.entries(store.form.steps).length -1 ? 'step-selected' : ''
              ]"
            />
          </div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "@/stores/store";

const store = useStore();
</script>
